module.exports = __webpack_public_path__ + "img/iconmonstr-arrow-65.cea5e582.svg";